import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as contractingActionCreators from '@makemydeal/dr-dash-store/actions/contractingActionCreators';
import * as lenderListSelectors from '@makemydeal/dr-dash-store/selectors/lenderListSelectors';
import { dealerSelectors, featureToggleSelectors } from '@makemydeal/dr-shared-store';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import { DeskingModeCTAValue } from '@makemydeal/dr-dash-store/types/dealModeEnum';
import { useChangeDealMode } from '@makemydeal/dr-dash-store/hooks/useChangeDealMode';
import { scopedActionsCreators } from '@makemydeal/shared-scoped-store';
import type { ContractFormType } from '@makemydeal/dr-dash-types';
import { FIXED_CONTRACT_FORM_TYPE_BY_STATE } from '../constants';

export const useHandleGenerateContract = () => {
    const dispatch = useDispatch();
    const isDealCentralWithFnI = useSelector(dealerSelectors.isDealCentralWithFnI);
    const isPaperLenderEnabled = useSelector(featureToggleSelectors.isPaperLenderEnabled);
    const isPaperLender = useSelector(lenderListSelectors.isSelectedLenderPaperLender);
    const dealerStateCode = useSelector(dealerSelectors.getDealerStateCode);
    const { handleChangeDealMode } = useChangeDealMode();
    const [showContractFormTypeModal, setShowContractFormTypeModal] = useState(false);

    const proceedWithContractGeneration = () => {
        dispatch(contractingActionCreators.validateContractFields());
    };

    const handleGenerateContract = () => {
        dispatch(contractingActionCreators.contractingGenerateClicked());
        dispatch(scopedActionsCreators.deleteNonPrimaryScopes());

        if (isDealCentralWithFnI) {
            handleChangeDealMode(DeskingModeCTAValue.FnIMode);
        }

        dispatch(interactionAnalyticsActionCreators.generateContractButton());

        if (isPaperLenderEnabled && isPaperLender) {
            const fixedFormType = FIXED_CONTRACT_FORM_TYPE_BY_STATE[dealerStateCode];
            if (fixedFormType) {
                dispatch(contractingActionCreators.setContractFormType(fixedFormType));
                proceedWithContractGeneration();
                return;
            }

            setShowContractFormTypeModal(true);
            return;
        }

        proceedWithContractGeneration();
    };

    const handleConfirmContractFormType = (formType: ContractFormType) => {
        setShowContractFormTypeModal(false);
        dispatch(contractingActionCreators.setContractFormType(formType));
        proceedWithContractGeneration();
    };

    const handleCloseContractFormTypeModal = () => setShowContractFormTypeModal(false);

    return {
        handleGenerateContract,
        showContractFormTypeModal,
        handleConfirmContractFormType,
        handleCloseContractFormTypeModal
    };
};
